import { render } from "./UseCouponPage.vue?vue&type=template&id=4717b940&scoped=true"
import script from "./UseCouponPage.vue?vue&type=script&lang=js"
export * from "./UseCouponPage.vue?vue&type=script&lang=js"

import "./UseCouponPage.vue?vue&type=style&index=0&id=4717b940&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4717b940"]])

export default __exports__